import type { Level } from "@/types/dictionary";

type Methods = Record<string, { direction: string; levels: Level[] }>;

export default class SearchRequestMethods {
  #methods: Methods = {};

  add(level: Level, direction: string, methodIds: string[]): void {
    if (methodIds.length === 0) {
      return;
    }

    methodIds.forEach((methodId) => {
      if (!this.#methods[methodId]) {
        this.#methods[methodId] = {
          direction,
          levels: []
        };
      }

      this.#methods[methodId].levels.push(level);
    });
  }

  filterByDirectionAndSourceLanguage(filter: string): void {
    const sourceLanguage = filter.slice(-4, -2);

    Object.keys(this.#methods).forEach((methodId) => {
      if (
        this.#methods[methodId].direction !== filter &&
        this.#methods[methodId].direction.slice(-4, -2) !== sourceLanguage
      ) {
        delete this.#methods[methodId];
      }
    });
  }

  getMethodIds(): string[] {
    return Object.keys(this.#methods);
  }

  get(): Methods {
    return this.#methods;
  }
}
